<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="post-search-page mb-4">
    <b-card v-if="post">
      <div class="d-flex full-width">
        <router-link :to="{ name: 'digital-replies' }">
          &laquo; Digital reply search
        </router-link>
        <div class="ui-spacer"></div>
        <router-link :to="{ name: 'post-view', params: { id: post.post_id } }">
          &laquo; View Original Post
        </router-link>
      </div>
    </b-card>

    <div class="row" v-if="!loading">
      <section class="col-12" v-if="post">

        <section class="details-overview">
          <h3 class="font-weight-bolder">Details</h3>

          <b-card>
            <div class="row">
              <p cy="sender" class="col-3"><b class="d-block">Sender </b> {{ post.sender_name }} ({{ post.sent_by }}) </p>
              <p cy="updated" class="col-3"><b class="d-block">Date </b> {{ post.updated_at | formatDateTime }} </p>
            </div>
          </b-card>
        </section>

        <section class="d-flex flex-wrap mb-3">
          <h3 class="full-width font-weight-bolder">Postcard</h3>
          <post-card :back-only="true" class="mx-auto" :post="post" />
        </section>
      </section>
      <section v-else>
        <h4>No reply found</h4>
      </section>
    </div>

    <section v-else>
      <b-spinner variant="primary" label="Loading reply"></b-spinner>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import DigitalRepliesService from '@/services/DigitalRepliesService';
  import PostCard from '@/views/postView/sections/PostCard.vue';

  export default {
    name: 'DigitalReplyView',
    components: {
      PostCard,
    },
    props: {
      id: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        loading: true,
        post: null,
      };
    },
    computed: {
      ...mapState({}),
    },
    mounted() {
      this.getPost();
    },
    methods: {
      getPost() {
        this.loading = true;
        DigitalRepliesService.getSingleReply(this.id).then(res => {
          this.post = res.data;
        }).catch(err => {
          console.log('could not get post', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
